// extracted by mini-css-extract-plugin
export default {"root":"DietFoodItem_root__9oq6V","link":"DietFoodItem_link__VY3tp","title":"DietFoodItem_title__vJKb7","placeHolderShimmer":"DietFoodItem_placeHolderShimmer__3jhmG"};